import React from "react";
import { ReactSVG } from "react-svg";

import starIcon from "../../assets/svg/solar--star-bold.svg";

export default function RatingStars({
   value = 0,
   previewValue = 0,
   max = 5,
   size = "md",
   interactive = false,
   disabled = false,
   className = "",
   accentColor = "",
   onChange,
   onPreviewChange,
}) {
   const rating = Number(value);
   const safe = Number.isFinite(rating)
      ? Math.max(0, Math.min(max, rating))
      : 0;
   const preview = Number(previewValue);
   const activeValue =
      interactive && Number.isFinite(preview) && preview > 0 ? preview : safe;
   const full = Math.floor(activeValue);
   const half = !interactive && activeValue - full >= 0.5;

   const rootClassName = [
      "ratingStars",
      `ratingStars--${size}`,
      interactive ? "ratingStars--interactive" : "",
      accentColor ? "ratingStars--palette" : "",
      className,
   ]
      .filter(Boolean)
      .join(" ");

   const rootStyle = accentColor
      ? { "--rating-accent": accentColor }
      : undefined;

   return (
      <div
         className={rootClassName}
         style={rootStyle}
         onMouseLeave={
            interactive ? () => onPreviewChange?.(0) : undefined
         }
         role={interactive ? "radiogroup" : undefined}
         aria-hidden={interactive ? undefined : true}
      >
         {Array.from({ length: max }, (_, index) => {
            const starValue = index + 1;
            let stateClass = "";

            if (interactive) {
               if (starValue <= full) stateClass = "is-active";
            } else if (index < full) {
               stateClass = "is-full";
            } else if (index === full && half) {
               stateClass = "is-half";
            }

            const icon = (
               <ReactSVG
                  src={starIcon}
                  className={`ratingStars__icon ${stateClass}`}
                  aria-hidden="true"
               />
            );

            if (interactive) {
               return (
                  <button
                     key={starValue}
                     type="button"
                     className={`ratingStars__button ${stateClass}`}
                     onMouseEnter={() => onPreviewChange?.(starValue)}
                     onFocus={() => onPreviewChange?.(starValue)}
                     onBlur={() => onPreviewChange?.(0)}
                     onClick={() => onChange?.(starValue)}
                     disabled={disabled}
                     aria-label={`${starValue} stele`}
                  >
                     {icon}
                  </button>
               );
            }

            return (
               <span key={starValue} className={`ratingStars__item ${stateClass}`}>
                  {icon}
               </span>
            );
         })}
      </div>
   );
}
